/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.544 3.5303c-.3082-.2929-.3082-.7677 0-1.0606.3081-.293.8078-.293 1.116 0L17.6871 12 7.6599 21.5303c-.3081.2929-.8078.2929-1.116 0-.3081-.2929-.3081-.7677 0-1.0606L15.4553 12 6.544 3.5303Zm6.3128-1.0606c.3082-.293.8078-.293 1.116 0L24 12l-10.0272 9.5303c-.3082.2929-.8078.2929-1.116 0-.3082-.2929-.3082-.7677 0-1.0606L21.7681 12l-8.9113-8.4697c-.3082-.2929-.3082-.7677 0-1.0606Zm-12.6257 18c-.3081.2929-.3081.7677 0 1.0606.3082.2929.8078.2929 1.116 0L11.3743 12 1.3471 2.4697c-.3082-.293-.8078-.293-1.116 0-.3081.2929-.3081.7677 0 1.0606L9.1424 12 .2311 20.4697Z"
    clipRule="evenodd"
  />,
  'Sync'
);
